// src/Redux/Store.js — BZ V2 aligned
import { configureStore } from '@reduxjs/toolkit';

// ── Common ────────────────────────────────────────────────────────────────────
import loginReducer from './Slices/Pages/Auth/LoginSlice';
import profileReducer from './Slices/Common/User/ProfileSlice';
import accountDeletionReducer from './Slices/Common/User/AccountDeletionSlice';
import catalogReducer from './Slices/Common/Catalog/CatalogSlice';
import locationReducer from './Slices/Common/Location/LocationSlice';
import notificationsReducer from './Slices/Common/Notifications/NotificationsSlice';
import otpReducer from './Slices/Common/OTP/OTPSlice';
import paymentReducer from './Slices/Common/Payment/PaymentSlice';
import bookingPaymentReducer from './Slices/Common/Payment/BookingPaymentSlice';
import enquiryReducer from './Slices/Pages/Payment/EnquirySlice';
import feedbackReducer from './Slices/Common/Feedback/FeedbackSlice';
import walletReducer from './Slices/Common/Wallet/WalletSlice';

// ── Provider (was: ServiceProvider) ──────────────────────────────────────────
import workspaceReducer from './Slices/Common/Workspace/WorkspaceSlice';
import businessReducer from './Slices/Pages/Provider/BusinessSlice';        // was: ServiceSlice (providerService)
import providerServicesReducer from './Slices/Pages/Provider/ServicesSlice';        // was: ServiceProviderServicesSlice
import availabilityReducer from './Slices/Pages/Provider/AvailabilitySlice';
import taskReducer from './Slices/Pages/Provider/TasksSlice';
import teamReducer from './Slices/Pages/Provider/ServiceTeamSlice';
import revenueReducer from './Slices/Pages/Provider/RevenueDetailsSlice';
import dashboardReducer from './Slices/Pages/Provider/DashboardSlice';
import professionalReducer from './Slices/Pages/Provider/ProfessionalSlice';
import postReducer from './Slices/Pages/Provider/PostSlice';

// ── Client ────────────────────────────────────────────────────────────────────
import businessListReducer from './Slices/Pages/Client/BusinessListSlice';          // was: Services.js (clientServices)
import serviceListReducer from './Slices/Pages/Client/ServiceListSlice';           // was: Services.js (service)
import bookingReducer from './Slices/Pages/Client/Booking/BookingSlice';
import reviewReducer from './Slices/Pages/Client/Review/ReviewSlice';
import uiReducer from './Slices/Pages/Client/Ui/Ui';
import countDownReducer from './Slices/Pages/Client/countDown';
import marketingReducer from './Slices/Pages/Client/Marketing/MarketingSlice';
import workspaceClassReducer from './Slices/Pages/Client/WorkspaceClassSlice';
import masterServiceReducer from './Slices/Pages/Client/MasterServiceSlice';
import discoveryReducer from './Slices/Pages/Client/DiscoverySlice';
import socialReducer from './Slices/Pages/Client/SocialSlice';

// ── Business Dashboard ────────────────────────────────────────────────────────
import businessProfileReducer from './Slices/Pages/Business/BusinessProfileSlice';
import businessTeamReducer from './Slices/Pages/Business/BusinessTeamSlice';

// ── Other ─────────────────────────────────────────────────────────────────────
import jobsReducer from './Slices/Pages/Jobs/JobsSlice';
import proposalReducer from './Slices/Pages/Proposal/ProposalSlice';
import professionReducer from './Slices/Pages/profession/ProfessionSlice';
// Removed adminManagement import

const store = configureStore({
  reducer: {
    // ── Common ──────────────────────────────────────────────────────────────
    login: loginReducer,
    profile: profileReducer,
    accountDeletion: accountDeletionReducer,
    catalog: catalogReducer,
    location: locationReducer,
    notifications: notificationsReducer,
    otp: otpReducer,
    payment: paymentReducer,
    bookingPayment: bookingPaymentReducer,
    enquiry: enquiryReducer,           // ✅ Enquiry-First (Request → Accept → Pay)
    wallet: walletReducer,

    // ── Provider ─────────────────────────────────────────────────────────────
    workspace: workspaceReducer,
    business: businessReducer,          // ✅ was: providerService
    providerServices: providerServicesReducer,  // ✅ was: serviceProviderServices
    availability: availabilityReducer,
    tasks: taskReducer,
    team: teamReducer,              // ✅ was: serviceTeam
    revenue: revenueReducer,           // ✅ was: revenueDetails
    dashboard: dashboardReducer,         // ✅ was: serviceProviderDashboard
    professional: professionalReducer,
    post: postReducer,

    // ── Client ───────────────────────────────────────────────────────────────
    businesses: businessListReducer,      // ✅ was: clientServices
    serviceList: serviceListReducer,       // ✅ was: service
    booking: bookingReducer,
    review: reviewReducer,
    ui: uiReducer,
    CountDown: countDownReducer,
    marketing: marketingReducer,
    workspaceClasses: workspaceClassReducer,
    masterServices: masterServiceReducer,
    discovery: discoveryReducer,
    social: socialReducer,

    // ── Business Dashboard ───────────────────────────────────────────────────
    businessProfile: businessProfileReducer,
    businessTeam: businessTeamReducer,

    // ── Other ────────────────────────────────────────────────────────────────
    jobs: jobsReducer,
    proposal: proposalReducer,
    profession: professionReducer,

    feedback: feedbackReducer,
  },
});

export default store;
